module.exports = __webpack_public_path__ + "img/storagePDF.72f210d1.svg";